"use client"

import { Button, Modal } from "antd"
import Image from "next/image"
import { useState } from "react"
import { ADMIN_API_CONFIG } from "../../../../../constants/api-configs"
import { DefaultImage, Media, MediaUpload } from "../../../../../lib/external-components"

interface SlideItemProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
}

interface SlideItemTextProps {
  value: string
  onChange: (value: string) => void
}

export const SlideItem = ({ value, onChange }: SlideItemProps | SlideItemTextProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value || "")

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url as any)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="flex flex-col gap-2">
      <input type="text" value={url} onChange={e => onChange(e.target.value as any)} placeholder="Image URL" readOnly />
      <div className="relative cursor-pointer group" onClick={() => openModal()}>
        <Image
          src={url ? `${ADMIN_API_CONFIG.API_URL}${url}` : DefaultImage}
          alt="Image"
          width={200}
          height={150}
          className="rounded-lg max-h-32 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
          <span className="text-white text-sm font-semibold drop-shadow-md">Change media</span>
        </div>
      </div>

      <Button
        onClick={() => openModal()}
        type="default"
        variant="outlined"
        className="bg-blue text-white p-2 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300"
      >
        Select Image
      </Button>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>
        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}
